'use client';
import React from 'react';
import { Table, Container } from 'react-bootstrap';

const DedicatedReseller: React.FC = () => {
  const tableData = [
    {
      servers: '5 to 19',
      bonus: 'None',
      hardware: 'None',
      endUser: 'Yes',
      discount: '3%',
    },
    {
      servers: '20 to 29',
      bonus: '$50',
      hardware: '3%',
      endUser: 'Yes',
      discount: '5%',
    },
    {
      servers: '30 to 49',
      bonus: '$100',
      hardware: '8%',
      endUser: 'Yes',
      discount: '8%',
    },
    {
      servers: '50 to 99',
      bonus: '$200',
      hardware: '10%',
      endUser: 'Yes',
      discount: '10%',
    },
    {
      servers: '100 to 199',
      bonus: '$400',
      hardware: '10%',
      endUser: 'Yes',
      discount: '12%',
    },
    {
      servers: '200 +',
      bonus: '$500',
      hardware: '10%',
      endUser: 'Yes',
      discount: '15%',
    },
  ];

  const signup_link = process.env.NEXT_PUBLIC_API_BASE_URL+'/cart.php?a=add&pid=102';
  return (
    <div className="my-4"> 
      <Container   className="p-0">
        <p className='text-center fs-5 textPara'>
        TEMOK offers an amazing dedicated reseller program. With our dedicated reseller program the more you sell the more you save! <br/>Our dedicated reseller 
        program is <a href={signup_link} className='textOrange text-decoration-none fw-bold'> FREE TO SIGNUP! </a> 
Addons such as additional IPs (with justification) and hard drives are available as upgrades,<br/> to allow your server to scale as your business does.
        </p>
      <h4 title="Dedicated Reseller Program" className="textHad fs-4 fw-bold text-center mb-3 mt-lg-5">
        Dedicated Reseller Program
      </h4>
        <Table striped   hover responsive>
          <thead className="table-light">
            <tr>
              <th className='textHad small px-4 py-3'>ACTIVE SERVERS</th>
              <th className='textHad small px-4 py-3'>ONE TIME BONUS</th>
              <th className='textHad small px-4 py-3'>HARDWARE UPGRADE DISCOUNT</th>
              <th className='textHad small px-4 py-3'>END-USER PROMOTIONS</th>
              <th className='textHad small px-4 py-3'>DEDICATED SERVER DISCOUNT</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                <td className="text-start textPara small px-4 py-3">{row.servers}</td>
                <td className="text-start textPara small  px-4 py-3">{row.bonus}</td>
                <td className="text-start textPara small  px-4 py-3">{row.hardware}</td>
                <td className="text-start textPara small  px-4 py-3">{row.endUser}</td>
                <td className="text-start textPara small  px-4 py-3">{row.discount}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </div>
  );
};

export default DedicatedReseller;
